import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { subscribeUser } from "../../Providers/subscribeProvider"; // Adjust path as needed
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram, faYoutube, faPinterestP, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import logo from "../../Assets/Logo/footerLogo.svg";
import icons from "../../icons.config";
import { navigateTo } from "../GlobalButton";
import TrackOrderPopup from "../ProfilePage/modals/trackOrderPopup";

const Footer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Get state from Redux store
  const { lastSubscribedEmail, subscribedEmails, status, error, isSubscribed } = useSelector(
    (state) => state.subscribe
  );

  const [email, setEmail] = useState("");
  const [subscribeMessage, setSubscribeMessage] = useState("");
    const [showTrackOrderPopup, setShowTrackOrderPopup] = useState(false);
    const authToken = useSelector((state) => state.auth.authToken);

  // Function to validate email format
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Prefill email from Redux store when lastSubscribedEmail changes
  useEffect(() => {
    console.log("Last Subscribed Email from Redux:", lastSubscribedEmail); // Debug log
    if (lastSubscribedEmail) {
      setEmail(lastSubscribedEmail);
    }
  }, [lastSubscribedEmail]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission

    if (!email.trim()) {
      setSubscribeMessage("⚠️ Please enter an email address!");
      return;
    }

    if (!isValidEmail(email)) {
      setSubscribeMessage("⚠️ Please enter a valid email address!");
      return;
    }

    // Dispatch the async thunk to subscribe
    const result = await dispatch(subscribeUser(email));

    if (subscribeUser.fulfilled.match(result)) {
      setSubscribeMessage("✅ Subscribed successfully!");
    } else {
      setSubscribeMessage(`❌ ${result.payload || "Subscription failed. Try again."}`);
    }
  };

  // Function for handling navigation with authentication check for "My Profile"
  const handleNavigation = (pathOrAction) => {
    if (pathOrAction === "/profile") {
      // Check authentication status for "My Profile"
      if (authToken) {
        navigate("/profile"); // Redirect to profile if authenticated
      } else {
        navigate("/login"); // Redirect to login if not authenticated
      }
    } else if (pathOrAction === "trackOrder") {
      // Check authentication status for "Track Order"
      if (authToken) {
        setShowTrackOrderPopup(true); // Show popup if authenticated
      } else {
        navigate("/login"); // Redirect to login if not authenticated
      }
    } else {
      navigate(pathOrAction); // Handle other paths normally
    }
  };

  return (
    <section className="footer-container overflow-hidden">
      <div className="bg-primary1 py-12 relative bottom-0 md:-top-0 overflow-hidden px-2 md:px-4">
        <div className="flex flex-col lg:flex-row justify-between items-start h-full">
          {/* Left Doodle Image in larger screens */}
          <div className="hidden lg:block absolute left-0 lg:top-52 xl:top-[53%]">
            <img src={icons.line1} alt="Doodle Left" className="lg:w-3/4 xl:w-2/3" />
          </div>

          {/* Logo and Tagline on the Left */}
          <div className="mb-6 lg:mb-0 flex flex-col items-start ml-[11%] md:ml-[4%] lg:ml-[8%] xl:ml-[125px]">
            <img
              src={logo}
              alt="Logo"
              className="w-40 mb-2 lg:w-48 h-[20%] cursor-pointer"
              onClick={() => navigate("/")}
            />
            <p className="text-md font-belleza mt-1 whitespace-nowrap text-primary2">
              Exquisite Fit, Premium Style
            </p>
            <div className="hidden lg:flex items-center mt-36">
              <img src={icons.flag} alt="flag icon" className="w-7 h-7" />
              <p className="text-sm font-medium ml-2 border-b-2 text-tertiary">INDIA</p>
            </div>
          </div>

          {/* Nav Links in 3 Columns */}
          <div className="flex flex-col lg:flex-row justify-center gap-6 lg:gap-24 w-full lg:w-2/4 mb-6 lg:mb-0 md:text-left lg:px-5 xl:px-0">
            <div className="flex flex-row ml-[10%] md:ml-[4%] lg:ml-0 lg:gap-20">
              <div className="text-md lg:text-sm w-full lg:w-auto">
                <h4 className="text-xl mb-3 font-outfit font-extralight text-primary2">
                  COMPANY
                </h4>
                <ul>
                  <li className="mb-2 font-poppins font-light text-sm text-tertiary">
                    <a
                      href="#"
                      className="hover:underline"
                      onClick={(e) => {
                        e.preventDefault();
                        navigateTo("/blogs");
                      }}
                    >
                      Blogs
                    </a>
                  </li>
                  <li className="mb-2 font-poppins font-light text-sm text-tertiary">
                    <a
                      href="#"
                      className="hover:underline"
                      onClick={(e) => {
                        e.preventDefault();
                        navigateTo("/aboutUs");
                      }}
                    >
                      About Us
                    </a>
                  </li>
                  <li className="mb-2 font-poppins font-light text-sm text-tertiary">
                    <a
                      href="#"
                      className="hover:underline"
                      onClick={(e) => {
                        e.preventDefault();
                        navigateTo("/contact");
                      }}
                    >
                      Contact Us
                    </a>
                  </li>
                  <li className="mb-2 font-poppins font-light text-sm text-tertiary">
                    <a
                      href="#"
                      className="hover:underline"
                      onClick={(e) => {
                        e.preventDefault();
                        navigateTo("/aboutus");
                      }}
                    >
                      FAQ's
                    </a>
                  </li>
                </ul>
              </div>

              <div className="text-md lg:text-sm w-full lg:w-auto">
                <h4 className="text-xl mb-3 font-outfit font-extralight text-primary2">
                  SHOP
                </h4>
                <ul>
                  <li className="mb-2 font-poppins font-light text-sm text-tertiary">
                    <a
                      href="#"
                      className="hover:underline"
                      onClick={(e) => {
                        e.preventDefault();
                        navigateTo("/shop");
                      }}
                    >
                      Shop All
                    </a>
                  </li>
                  <li className="mb-2 font-poppins font-light text-sm text-tertiary">
                    <a
                      href="#"
                      className="hover:underline"
                      onClick={(e) => {
                        e.preventDefault();
                        navigateTo("/shop");
                      }}
                    >
                      Sale
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="text-md w-full lg:w-auto ml-[10%] md:ml-[4%] lg:ml-0 lg:text-sm">
              <h4 className="text-xl mb-3 font-outfit font-extralight text-primary2">
                INFORMATION
              </h4>
              <ul>
              <li className="mb-2 font-poppins font-light text-sm text-tertiary">
                  <a
                    href="#"
                    className="hover:underline"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavigation("trackOrder"); // Use handleNavigation for Track Order
                    }}
                  >
                    Track Order
                  </a>
                  {showTrackOrderPopup && (
                    <TrackOrderPopup onClose={() => setShowTrackOrderPopup(false)} />
                  )}
                </li>
                <li className="mb-2 font-poppins font-light text-sm text-tertiary">
                  <a
                    href="#"
                    className="hover:underline"
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavigation("/profile"); // Use handleNavigation instead of direct href
                    }}
                  >
                    My Profile
                  </a>
                </li>
                <li className="mb-2 font-poppins font-light text-sm text-tertiary">
                  <a href="/exchange-and-return" className="hover:underline">
                    Exchange & Return Policy
                  </a>
                </li>
                <li className="mb-2 font-poppins font-light text-sm text-tertiary">
                  <a href="/privacy-policy" className="hover:underline">
                    Privacy Policy
                  </a>
                </li>
                <li className="mb-2 font-poppins font-light text-sm text-tertiary">
                  <a href="/terms-and-conditions" className="hover:underline">
                    Terms & Conditions
                  </a>
                </li>
                <li className="mb-2 font-poppins font-light text-sm text-tertiary">
                  <a href="/contact" className="hover:underline">
                    Help
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Stay Tuned with Email Subscription */}
          <div className="w-3/4 lg:w-1/4 flex flex-col items-start lg:mr-[6%] xl:mr-[9%] ml-[10%] md:ml-[4%] lg:ml-0">
            <h4 className="text-xl mb-3 font-outfit font-extralight text-primary2">
              STAY TUNED
            </h4>
            <p className="text-sm mb-4 font-poppins font-light text-tertiary">
              Sign up to stay tuned about our new arrivals, collections, sale and more.
            </p>

            <form className="flex w-full flex-col" onSubmit={handleSubmit}>
              <div className="flex w-full">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full p-2 rounded-l-lg bg-tertiary text-hcolor placeholder-hcolor placeholder:font-outfit placeholder:font-normal font-medium"
                  placeholder="Your Email Address"
                  required
                />
                <div
                  className="flex items-center bg-tertiary p-2 rounded-r-lg pr-4 cursor-pointer"
                  onClick={handleSubmit}
                >
                  <div className="border-l-2 border-hcolor h-6 px-1"></div>
                  <img
                    src={isSubscribed ? icons.emailTick : icons.arrow}
                    alt={isSubscribed ? "success icon" : "arrow icon"}
                    className="w-8 h-8"
                  />
                </div>
              </div>

              {(subscribeMessage || error) && (
                <p className="mt-2 text-sm text-tertiary text-left">
                  {subscribeMessage || error}
                </p>
              )}
            </form>

            <div className="pt-8 lg:pt-20">
              <h4 className="mb-3 font-outfit font-light text-primary2">
                FOLLOW US ON
              </h4>
              <div className="flex space-x-6 text-tertiary">
                <a
                  href="https://www.whatsapp.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-2xl hover:hcolor"
                >
                  <FontAwesomeIcon icon={faWhatsapp} />
                </a>
                <a
                  href="https://www.instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-2xl hover:hcolor"
                >
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a
                  href="https://www.facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-2xl hover:hcolor"
                >
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a
                  href="https://www.youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-2xl hover:hcolor"
                >
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
                <a
                  href="https://www.pinterest.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-2xl hover:hcolor"
                >
                  <FontAwesomeIcon icon={faPinterestP} />
                </a>
              </div>

              <div className="flex items-center mt-7 lg:hidden">
                <img src={icons.flag} alt="flag icon" />
                <p className="text-sm font-medium ml-2 border-b-2 text-tertiary">INDIA</p>
              </div>

              <div className="lg:hidden">
                <div className="absolute left-0 bottom-0">
                  <img src={icons.mline1} alt="Doodle Left" className="w-full" />
                </div>
                <div className="absolute -right-2 bottom-0">
                  <img src={icons.mline2} alt="Doodle Right" className="w-full" />
                </div>
              </div>
            </div>
          </div>

          <div className="hidden lg:block absolute lg:-right-32 lg:top-[52%] xl:-right-24 xl:top-[31%]">
            <img src={icons.line2} alt="Doodle Right" className="lg:w-2/4 xl:w-2/3" />
          </div>
        </div>

        <div className="text-center flex justify-center bottom-1 md:bottom-2 absolute left-[31%] md:left-[46%]">
          <p className="text-xs font-outfit font-light text-primary2">
            Developed by Pixwala
          </p>
        </div>
      </div>
    </section>
  );
};

export default Footer;